// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09ec1ad9","355":"83ce0533","732":"1917fef5","736":"6938e95f","977":"b9e47d70"}[chunkId] + ".chunk.js";
};